<template>
  <div class="container">
    <img src="@/assets/tg/tg4_title.png" alt="" class="title" />
    <div class="content">
      <div class="query-box">
        <h2><img src="@/assets/tg/tg4_arrow_down.png" alt="" />考生查询</h2>
        <div class="line"></div>
        <div class="form-item" style="margin-top: 45px">
          <select v-model="province" :style="{ color: province.length ? '#000' : '#6A6A6A' }">
            <option value="" disable>请选择您的报考省份</option>
            <option value="河南省">河南省</option>
            <option value="北京市">北京市</option>
            <option value="天津市">天津市</option>
            <option value="河北省">河北省</option>
            <option value="山西省">山西省</option>
            <option value="内蒙古自治区">内蒙古自治区</option>
            <option value="辽宁省">辽宁省</option>
            <option value="吉林省">吉林省</option>
            <option value="黑龙江省">黑龙江省</option>
            <option value="上海市">上海市</option>
            <option value="江苏省">江苏省</option>
            <option value="浙江省">浙江省</option>
            <option value="安徽省">安徽省</option>
            <option value="福建省">福建省</option>
            <option value="江西省">江西省</option>
            <option value="山东省">山东省</option>
            <option value="湖北省">湖北省</option>
            <option value="湖南省">湖南省</option>
            <option value="广东省">广东省</option>
            <option value="广西壮族自治区">广西壮族自治区</option>
            <option value="海南省">海南省</option>
            <option value="重庆市">重庆市</option>
            <option value="四川省">四川省</option>
            <option value="贵州省">贵州省</option>
            <option value="云南省">云南省</option>
            <option value="西藏自治区">西藏自治区</option>
            <option value="陕西省">陕西省</option>
            <option value="甘肃省">甘肃省</option>
            <option value="青海省">青海省</option>
            <option value="宁夏回族自治区">宁夏回族自治区</option>
            <option value="新疆维吾尔自治区">新疆维吾尔自治区</option>
            <option value="台湾">台湾</option>
            <option value="香港">香港</option>
            <option value="澳门">澳门</option>
          </select>
          <div class="arrow"></div>
        </div>
        <div class="form-item">
          <input type="text" placeholder="请输入您的手机号" v-model="mobile" maxlength="11" />
        </div>
        <button @click="queryClick">提交信息</button>
        <!-- <div class="agree">
          <label>
            <input type="checkbox" v-model="isAgree" style="width: 15px; height: 15px" />
            <p>已阅读并接受《用户服务协议》和《隐私政策》</p>
          </label>
        </div> -->
        <div class="line" style="margin-top: 36px"></div>
      </div>
      <div class="hint-box">
        <h3>友情提示</h3>
        <ul>
          <li>1.本网站提供2024年二级建造师资格考试信息查询服务；</li>
          <li>2.二级建造师考试报考条件要求中专及以上学历及对应工作经验，部分省份报考条件有所放宽，考生可选择省份查询报考信息；</li>
          <li>
            3.二级建造师考试由各省自行组织，报名时间、考试时间等报考信息各有不同，依据各省《二级建造师执业资格考试有关工作的通知》而定，考生可选择省份查询该省报考详细信息；
          </li>
          <li>4.常规报考信息查询结果将以短信或语音的形式反馈给您，非常规问题将为您提供二级建造师考试问题免费人工服务，服务时间：工作日9点-18点。</li>
        </ul>
      </div>
      <div class="copy-right">济南实学求事教育咨询有限公司长春分公司</div>
    </div>
    <el-dialog
      class="submit-dialog"
      style="border-radius: 10px"
      :visible.sync="dialogVisible"
      :show-close="false"
      center
      width="480px"
      append-to-body
    >
      <div class="submitMian">已提交，该省份信息查询已为您转接人工客服，<br />服务时间：9:00——18:00,请注意接听。</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import md5 from 'js-md5'
import { phoneValidator, isMobile } from '@/utils/index'
import { graduatePromot } from '@/api/index.js'
export default {
  data() {
    return {
      province: '',
      userName: '',
      mobile: '',
      isAgree: false,
      isLoading: false,
      dialogVisible: false
    }
  },
  computed: {
    agreeUrl() {
      return isMobile()
        ? 'https://x.zhongke3.com/apis/coursera/common/rich/text/1/71d76ae3eb8e42ce9c5d8151fffc9192'
        : 'https://x.zhongke3.com/zj-wx-web-pc/login/protocol?type=1'
    },
    privacyUrl() {
      return isMobile()
        ? 'https://x.zhongke3.com/apis/coursera/common/rich/text/1/8a6eef758fb44d1db7f0a43834d33edd'
        : 'https://x.zhongke3.com/zj-wx-web-pc/login/protocol?type=2'
    }
  },
  methods: {
    queryClick() {
      if (!this.province.length) {
        return this.$message.error('请选择您的报考省份')
      }

      if (!this.mobile.length) {
        return this.$message.error('请输入您的手机号')
      }

      if (!phoneValidator(this.mobile)) {
        return this.$message.error('手机号格式错误')
      }

      if (this.isLoading) {
        return
      }
      this.isLoading = true
      const gt = new Date().getTime().toString()
      graduatePromot({
        time: gt,
        encryPwd: md5(gt + 'verify'),
        mobile: this.mobile,
        originurl: window.location.origin + window.location.pathname,
        collegeName: '二级建造师',
        orign: '百度信息流',
        promotedAccount: '实学教育吉wq06-sl',
        remark: `报考省份：${this.province}`
      })
        .then(res => {})
        .finally(() => {
          window._agl && window._agl.push(['track', ['success', { t: 3 }]])

          this.province = ''
          this.mobile = ''
          this.dialogVisible = true
          this.isLoading = false
        })
    }
  },
  mounted() {
    window._agl = window._agl || []
    window._agl.push(['production', '_f7L2XwGXjyszb4d1e2oxPybgD'])
    const agl = document.createElement('script')
    agl.type = 'text/javascript'
    agl.async = true
    agl.src = 'https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD'
    const s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(agl, s)
  },
  metaInfo() {
    return {
      title: `二级建造师考试信息网`
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-size: 100% 100%;
  background-image: url(https://zk-web-source.oss-cn-beijing.aliyuncs.com/tg/tg4_bg.png);
  overflow: scroll;
  background-attachment: fixed;
  .title {
    padding-top: 100px;
    padding-bottom: 50px;
    text-align: center;
  }
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 40px;
    .hint-box {
      margin-top: 50px;
      h3 {
        font-size: 26px;
        font-weight: bold;
        font-family: Microsoft YaHei;
        text-shadow: 2px 2px 0 #fff;
        color: #de0000;
      }
      ul {
        list-style: none;
        width: 1020px;
        li {
          margin-top: 6px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          color: #302f30;
        }
      }
    }
    .query-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-shrink: 0;
      width: 825px;
      height: 535px;
      background: url(https://zk-web-source.oss-cn-beijing.aliyuncs.com/tg/tg4_form_bg.png) no-repeat;
      h2 {
        display: flex;
        align-items: center;
        padding-top: 30px;
        padding-bottom: 20px;
        font-size: 35px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #000;
        img {
          width: 56px;
          height: 56px;
          margin-right: 15px;
        }
      }
      .line {
        height: 2px;
        width: 625px;
        background-color: rgb(255, 232, 232);
      }
      .form-item {
        position: relative;
        display: flex;
        align-items: center;
        margin-top: 20px;
        select,
        input {
          width: 625px;
          height: 70px;
          padding-left: 20px;
          background: #ffffff;
          font-size: 18px;
          border: 1px solid rgb(222, 222, 222);
          box-sizing: border-box;
          outline: none;
        }
        select {
          appearance: none;
          -moz-appearance: none;
          -webkit-appearance: none;
        }
        .arrow {
          position: absolute;
          top: 0;
          right: 0;
          width: 12px;
          height: 12px;
          margin-right: 16px;
          margin-top: 26px;
          transform: rotate(45deg);
          border-bottom: 2px solid #000;
          border-right: 2px solid #000;
        }
      }
      button {
        width: 360px;
        height: 64px;
        margin-top: 40px;
        font-size: 22px;
        color: #ffffff;
        font-weight: bold;
        background: linear-gradient(90deg, rgb(254, 100, 101), rgb(219, 20, 21));
        border-radius: 10px;
        outline: none;
        border: none;
        cursor: pointer;
      }
      .agree {
        label {
          display: flex;
          align-items: center;
          margin-top: 23px;
          cursor: pointer;
          input {
            margin: 0;
          }
          p {
            color: #868686;
            margin: 0 0 0 10px;
            a {
              color: #e5170d;
              text-decoration: none;
            }
          }
        }
      }
    }
  }
  .copy-right {
    margin-top: 20px;
    line-height: 40px;
    text-align: center;
    color: rgb(91, 91, 91);
  }
}

.submit-dialog {
  ::v-deep .el-dialog__wrapper {
    border-radius: 10px !important;
  }
  .submitMian {
    font-size: 20px;
    color: #000;
  }
  .el-button {
    width: 240px;
    height: 60px;
    border: none;
    font-size: 22px;
    border-radius: 10px;
    background: linear-gradient(90deg, rgb(254, 100, 101), rgb(219, 20, 21));
  }
  ::v-deep .el-dialog {
    border-radius: 10px;
  }
}

@media (max-width: 992px) {
  .container {
    .title {
      width: 60%;
      padding: 30px 0px;
    }
    .content {
      zoom: 80%;
      .query-box {
        zoom: 90%;
      }
      .hint-box {
        zoom: 80%;
      }
    }
  }
}

@media (min-width: 993px) and (max-width: 1280px) {
  .container {
    .title {
      width: 50%;
      padding: 60px 0px;
    }
    .content {
      zoom: 80%;
      .query-box {
        zoom: 70%;
      }
      .hint-box {
        zoom: 70%;
      }
    }
  }
}

@media (min-width: 1921px) {
  .container {
    .content {
      zoom: 95%;
    }
  }
}
</style>
<style>
body {
  min-width: 100%;
}
</style>
